import React from 'react'

import Seo from '../../components/seo'
//import Navigation from '~/components/Navigation'
import { Container, MainContent } from '../../utils/styles'
import Footer from '../../components/Footer'
import Navigation from '../../components/Navigation'

const Page = ({ title, children, color = 'transparent' }) => (
  <div style={{ backgroundColor: color }}>
    <Seo title={title} />
    <Navigation />
    <Container>
      <MainContent>{children}</MainContent>
    </Container>
    <Footer />
  </div>
)

export default Page
